import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../Intl';
import { CoinDollar, CoinPound, LockShield, LuggageGlobe, Tea } from './Icons/Icons';
import EdapModuleView from '../EdapModuleView';
import { MODULE_VIEW_EVENT_OPTIONS } from './events';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import cnames from 'classnames';

import './NewValueProps.less';

const CNAME = 'NewValueProps';

class NewValueProps extends Component {
  componentDidMount() {
    const newValuePropsExp = AbacusClientUtils.evaluateExperiment('HA_PTA_HP_NewValueProps');
    if (newValuePropsExp.value === 1) {
      AbacusClientUtils.logExperiment(newValuePropsExp);
    }
  }

  render() {
    const NewValuePropsItem = ({ title, blurb, icon, isTablet }) => (
      <li className={`${CNAME}__item col-xs-12 col-sm-6 col-md-3`}>
        <div className={`${CNAME}__itemicon`}>
          {icon}
        </div>
        <div className={cnames(`${CNAME}__itemtext`, { [`${CNAME}__itemtext--isTablet`]: isTablet })} >
          <h3 className={`${CNAME}__title`}>{title}</h3>
          <p className={`${CNAME}__blurb small`} dangerouslySetInnerHTML={{ __html: blurb }} />
        </div>
      </li>
    );

    const currencyMap = {
      USD: <CoinDollar />,
      GBP: <CoinPound />,
      default: <CoinDollar />
    };

    const { currency, isTablet } = this.props;

    return (
      <section className="Content__section">
        <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
          <ul className={cnames(`${CNAME}__list`, 'row', 'app-wrapper', { 'app-wrapper--isTablet': isTablet })}>
            <FormattedMessage id={['safety.new.title', 'safety.new.text']}>
              {(title, blurb) => (<NewValuePropsItem icon={<LockShield />} {...{ title, blurb, isTablet }} />)}
            </FormattedMessage>
            <FormattedMessage id={['experience.new.title', 'experience.new.text']}>
              {(title, blurb) => (<NewValuePropsItem icon={<LuggageGlobe />} {...{ title, blurb, isTablet }} />)}
            </FormattedMessage>
            <FormattedMessage id={['selection.new.title', 'selection.new.text']}>
              {(title, blurb) => (<NewValuePropsItem icon={<Tea />} {...{ title, blurb, isTablet }} />)}
            </FormattedMessage>
            <FormattedMessage id={['value.new.title', 'value.new.text']}>
              {(title, blurb) => (<NewValuePropsItem icon={currencyMap[currency] || currencyMap.default} {...{ title, blurb, isTablet }} />)}
            </FormattedMessage>
          </ul>
        </EdapModuleView>
      </section>
    );
  }
}

NewValueProps.propTypes = {
  currency: PropTypes.string.isRequired,
  isTablet: PropTypes.bool.isRequired,
  title: PropTypes.string,
  blurb: PropTypes.string
};

export default NewValueProps;



// WEBPACK FOOTER //
// ./src/universal/components/ValueProps/NewValueProps.js